import caireLogo from "@/assets/caire-logo.png";
import caireLogoWhite from "@/assets/caire-logo-white.png";
import { useTheme } from "next-themes";

/** CAIRE logo — auto-switches between dark/light variants based on theme. */
export const StackedLogo = ({ size = 16 }: { size?: number; color?: string }) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <img
      src={isDark ? caireLogoWhite : caireLogo}
      alt="CAIRE"
      style={{ height: size * 1.5, width: "auto" }}
      className="object-contain"
    />
  );
};
